import loadable from "@loadable/component"
import PropTypes from "prop-types"

import { retry } from "helpers/application"

import FilterPanel from "./filter-panel"
import withFilters from "./hoc/with-filters"

const HolidayDeliveryToggle = loadable(() =>
  retry(() => import("./holiday-delivery-toggle"))
)

/**
 * Collection filters accordion
 * @param  {array} collectionFilters - all filter categories in collection
 */
const InternalFilterAccordion = ({ collectionFilters, isMobile }) => {
  if (!collectionFilters) return null

  return collectionFilters.map((filter) =>
    filter.delivery_category ? (
      <HolidayDeliveryToggle filter={filter} key={filter.name} />
    ) : (
      <FilterPanel filter={filter} isMobile={isMobile} key={filter.name} />
    )
  )
}

InternalFilterAccordion.propTypes = {
  collectionFilters: PropTypes.array,
  isMobile: PropTypes.bool,
}

const FilterAccordion = withFilters(InternalFilterAccordion)

export default FilterAccordion
